import { getCookie, setCookie, removeCookie } from 'typescript-cookie';
import {
  COOKIE_NAME_UTM_SOURCE,
  COOKIE_NAME_UTM_MEDIUM,
  COOKIE_NAME_UTM_CAMPAIGN,
  COOKIE_NAME_ZIP_CODE,
} from '../../../constants/constant';

export interface CookieAttributes {
  path?: string;
  domain?: string;
  expires?: number | Date;
  sameSite?: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None';
  secure?: boolean;
}

export const getCookieByName = (cookieName: string): string => {
  return getCookie(cookieName) ?? '';
};

export const addCookie = (cookieName: string, cookieValue: string, cookieAttributes: CookieAttributes) => {
  return setCookie(cookieName, cookieValue, cookieAttributes);
};

export const deleteCookie = (cookieName: string, cookieAttributes: CookieAttributes) => {
  return removeCookie(cookieName, cookieAttributes);
};

export const getPrequalCookies = () => {
  const utmCampaignMedium = getCookieByName(COOKIE_NAME_UTM_MEDIUM);
  const utmCampaignName = getCookieByName(COOKIE_NAME_UTM_CAMPAIGN);
  const utmCampaignSource = getCookieByName(COOKIE_NAME_UTM_SOURCE);
  const cookies = {
    ...(utmCampaignSource && { utmCampaignSource }),
    ...(utmCampaignMedium && { utmCampaignMedium }),
    ...(utmCampaignName && { utmCampaignName }),
  };
  return cookies;
};

export const getCookieZipCode = () => {
  return getCookieByName(COOKIE_NAME_ZIP_CODE);
};
